import CarrouselProducts from './CarrouselProducts';

export default CarrouselProducts;
